import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Ban } from "lucide-react";

export const ExclusionModal = ({
  exclusionModal,
  setExclusionModal,
  exclusionReason,
  setExclusionReason,
  handleExclude,
  selectedTxns,
}) => {
  const close = () => setExclusionModal({ open: false, txnId: null, txnName: "", isBulk: false });
  return (
    <Dialog open={exclusionModal.open} onOpenChange={(open) => !open && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{exclusionModal.isBulk ? "Bulk Exclude Transactions" : "Exclude Transaction"}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-slate-600 mb-4">
            Excluding: <strong>{exclusionModal.txnName}</strong>
          </p>
          <Label className="text-sm font-medium">
            Reason for Exclusion <span className="text-red-500">*</span>
          </Label>
          <Textarea
            value={exclusionReason}
            onChange={(e) => setExclusionReason(e.target.value)}
            placeholder="Enter reason for excluding (mandatory)..."
            className="mt-2"
            rows={3}
            data-testid="exclusion-reason-input"
          />
          <p className="text-xs text-slate-500 mt-1">This helps in audit trail and rectification workings.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="exclusion-cancel-btn">
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleExclude} disabled={!exclusionReason.trim()} data-testid="exclusion-confirm-btn">
            <Ban className="w-4 h-4 mr-2" />
            Exclude {exclusionModal.isBulk ? `(${selectedTxns.size})` : ""}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
